import { InfoIcon } from '@mm/icons';
import React, { useState } from 'react';
import {
  FollowUpKind,
  FollowUpModel,
  FollowUpStateType,
  QqFollowUpModel,
} from '@mm/state/model/FollowUpModel';
import { NeedHelpLabel } from '../../../../common/components/NeedHelpLabel/NeedHelpLabel';
import './FollowUps.pcss';
import { FollowUpsAccordionItems } from './FollowUpsAccordionItems';
import { useNewGraphInstance } from '../../../../../../common/widgets/common/PathGraph/PathGraph';

type Props = {
  followUps: Record<FollowUpStateType, FollowUpModel<QqFollowUpModel>[]>;
  className?: string;
};

export const FollowUps = (props: Props) => {
  const [activeKind, setActiveKind] = useState<FollowUpKind | undefined>(
    'qq_follow_up',
  );
  const inboxRules = {
    pendingFollowUps: props.followUps.pendingFollowUps,
    resolvedFollowUps: props.followUps.resolvedFollowUps,
  };
  const chatDialogueRules = {
    qqFollowUps: props.followUps.qqFollowUps,
  };

  return (
    <div className="follow-ups">
      <div className="follow-ups__heading">
        Automatic Follow Up
        <NeedHelpLabel link="https://mobilemonkey.com/help/article/vd6jbkjwo5-automation-rules" />
      </div>
      <div className="follow-ups__info-message">
        <InfoIcon className="follow-ups__info-icon" />
        <span>Send follow up messages to your contacts</span>
      </div>
      <div className="follow-ups__category-heading">
        Inbox Rules <div className="follow-ups__category-heading-line" />
      </div>
      <FollowUpsAccordionItems
        activeKind={activeKind}
        setActiveKind={setActiveKind}
        followUps={inboxRules}
      />
      <div className="follow-ups__category-heading">
        Chat Dialogue Rules{' '}
        <div className="follow-ups__category-heading-line" />
      </div>
      <FollowUpsAccordionItems
        activeKind={activeKind}
        setActiveKind={setActiveKind}
        followUps={chatDialogueRules}
      />
    </div>
  );
};
